import { apiFetch } from './apiClient';

export async function fetchCurrentUser() {
  return apiFetch('/api/auth/me');
}

export async function fetchUserSettings() {
  return apiFetch('/api/auth/settings');
}

export async function updateUserSetting({ settingSlug, settingValue }) {
  return apiFetch('/api/auth/settings', {
    method: 'PUT',
    body: JSON.stringify({
      setting_slug: settingSlug,
      setting_value: settingValue,
    }),
  });
}

export async function updateProfile({ firstName, lastName }) {
  return apiFetch('/api/auth/profile', {
    method: 'POST',
    body: JSON.stringify({
      first_name: firstName,
      last_name: lastName,
    }),
  });
}

export async function fetchRoles() {
  return apiFetch('/api/auth/roles');
}

export async function fetchCmsUsers() {
  return apiFetch('/api/auth/cms-users');
}

export async function fetchCmsUser(userId) {
  return apiFetch(`/api/auth/cms-users/${encodeURIComponent(userId)}`);
}

export async function updateCmsUser(userId, { firstName, lastName, roleId, siteIds }) {
  return apiFetch(`/api/auth/cms-users/${encodeURIComponent(userId)}`, {
    method: 'PUT',
    body: JSON.stringify({
      first_name: firstName,
      last_name: lastName,
      role_id: roleId,
      site_ids: siteIds,
    }),
  });
}

export async function fetchUsers({ page = 0, perPage = 50 } = {}) {
  const params = new URLSearchParams({
    page: String(page),
    perPage: String(perPage)
  });

  return apiFetch(`/api/auth/users?${params.toString()}`);
}

export async function fetchUserRoles(userId) {
  return apiFetch(`/api/auth/users/${encodeURIComponent(userId)}/roles`);
}

export async function assignUserRoles(userId, roleIds) {
  return apiFetch(`/api/auth/users/${encodeURIComponent(userId)}/roles`, {
    method: 'POST',
    body: JSON.stringify({ roleIds })
  });
}

export async function removeUserRoles(userId, roleIds) {
  return apiFetch(`/api/auth/users/${encodeURIComponent(userId)}/roles`, {
    method: 'DELETE',
    body: JSON.stringify({ roleIds })
  });
}
